import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { useServices } from "@/app/use-services";

/**
 * Tells analytics which screen is in front, at the top of every route.
 *
 * A layout effect, not a plain effect: it runs in the same commit that puts
 * the new screen's DOM in place, before the replay recorder processes that
 * DOM, so a masked screen's words are never recorded even for one frame.
 */
export function ScreenTracker() {
  const { analytics } = useServices();
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    analytics.screen(pathname);
  }, [analytics, pathname]);
  return <Outlet />;
}
